<template>
  <div style="height:100%;display:flex;flex-direction:column;">
    <div style="height:196px;background:#fff;border-radius:4px;padding:24px">
      <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">我的短信接口</div>
      <div style="margin-top:20px;">
        <div v-if="msgSupportData==null" style="display:inline-block;width:206px;height:104px;padding:20px 19px;background:rgba(242, 243, 245, 1);color:rgba(80, 80, 80, 1);font-size:12px;text-align:center;line-height:23px;">
          <div>您还未开通短信接口</div>
          <div>请访问官网www.ixiaowen.net</div>
          <div>联系客服授权开通</div>
        </div>
        <div v-if="msgSupportData!=null" style="display:inline-block;width:206px;height:104px;margin-right:25px;border:1px solid rgba(121, 136, 155, 0.3);border-radius:4px;text-align:center;padding-top:30px;">
          <img style="width:140px;" :src="msgSupportData.picture" alt="">
        </div>
      </div>
    </div>
    <div style="flex:1;margin-top:16px;background:#fff;padding:24px;border-radius:4px">
      <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">已集成短信接口</div>
      <div style="margin-top:20px;">
        <div v-if="integratedMsgData.length==0" style="display:inline-block;width:206px;height:104px;padding:20px 19px;background:rgba(242, 243, 245, 1);color:rgba(80, 80, 80, 1);font-size:12px;text-align:center;line-height:23px;">
          <div>您还未开通短信接口</div>
          <div>请访问官网www.ixiaowen.net</div>
          <div>联系客服授权开通</div>
        </div>
        <div v-for="(item,index) in integratedMsgData" :key='index' style="display:inline-block;width:206px;height:104px;margin-right:25px;border:1px solid rgba(121, 136, 155, 0.3);border-radius:4px;text-align:center;padding-top:30px;">
          <img style="width:140px;" :src="item.picture" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountInfo',
  props: {
    msg: String
  },
   data() {
    return {
      msgSupportData: null,
      integratedMsgData: []
    } 
  },
  methods: {
    queryMyMsgInterface() {
      this.axios(
        {
          method:'get',
          url:'/api/supplier/mySupplier', 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.msgSupportData = response.data.data
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //     this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryIntegratedMsg() {
      this.axios(
        {
          method:'get',
          url:'/api/supplier/list', 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.integratedMsgData = response.data.data
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //     this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error)
      })
    }
  },
  mounted: function() {
    this.sessionData('set','contentNavItem','AccountInfo');
    this.queryMyMsgInterface()
    this.queryIntegratedMsg()
  }
}
</script>

<style scoped lang="less">
 
</style>
